import { ensureSpeechRecognitionBootstrap } from '@/utils/speechRecognitionBootstrap';

ensureSpeechRecognitionBootstrap();
